import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  banner: {
    position: 'relative',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: '13%',
      marginRight: '8%',
      marginTop: '2%',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '5%',
      marginRight: '3%',
    },
  },
  noticePage: {
    [theme.breakpoints.up('md')]: {
      marginLeft: '30px',
      marginRight: '70px',
      marginTop: '2%',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '5%',
      marginRight: '3%',
    },
  },
  noOfUploadedDocs: {
    [theme.breakpoints.up('md')]: {
      marginLeft: '5rem',
    },
  },
  paragraph: {
    [theme.breakpoints.down('md')]: {
      fontSize: '100%',
      color: '#333333',
      paddingBottom: '20px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '150%',
    },
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  close: {
    cursor: 'pointer',
  },

  clrButton: {
    float: 'right',
    textTransform: 'capitalize',
    fontWeight: 600,
    color: '#0055A5',
    [theme.breakpoints.down('md')]: { marginRight: '-9px' },
    [theme.breakpoints.up('lg')]: { marginRight: '-12px' },
  },
  paper: {
    backgroundColor: '#E0E1E1',
    position: 'relative',
    padding: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      marginTop: '3%',
      paddingLeft: '5%',
      paddingRight: '5%',
      paddingBottom: '3%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
  },
  loadingpaper: { border: '1px', borderStyle: 'solid' },
  uploadPaper: {
    backgroundColor: '#E0E1E1',
    position: 'relative',

    [theme.breakpoints.up('lg')]: {
      marginTop: '3%',
      paddingLeft: '5%',
      paddingRight: '5%',
      paddingBottom: '3%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
  },
  txtField: {
    backgroundColor: 'white',
    width: '100%',
  },
  txtFldLbl: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '10px',
  },
  button: {
    fontSize: '12px',
    background:
      'linear-gradient(180deg, rgba(0,102,204,1) 74%, rgba(123,174,225,1) 100%);',
    textTransform: 'capitalize',

    marginTop: '1rem',
    width: '100%',
  },

  allCenter: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  otpOverlay: {
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
      zIndex: 9999,
      right: '0px',
      bottom: '0px',
      top: '0px',
      left: '0px',
      borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      zIndex: 9999,
      right: '0px',
      bottom: '0px',
      top: '0px',
      left: '0px',
      borderRadius: '8px',
    },
  },
  otpBackground: {
    [theme.breakpoints.up('md')]: {
      zIndex: '-1',
      position: 'fixed',
      right: '0px',
      bottom: '0px',
      top: '0px',
      left: '0px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      WebkitTapHighlightColor: 'transparent',
    },
    [theme.breakpoints.down('md')]: {
      zIndex: '-1',
      position: 'fixed',
      right: '0px',
      bottom: '0px',
      top: '0px',
      left: '0px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      WebkitTapHighlightColor: 'transparent',
    },
  },
  otpPaper: {
    [theme.breakpoints.up('md')]: {
      top: '52%',
      left: '50%',
      transform: 'translate(-52%,-45%)',
      paddingTop: '0px',
      paddingLeft: '0px',
      paddingRight: '11px',
      paddingBottom: '16px',
      position: 'absolute',
      width: '400px',
      textAlign: 'center',
      borderRadius: '10px',
    },
    [theme.breakpoints.down('md')]: {
      top: '52%',
      left: '50%',
      transform: 'translate(-50%,-55%)',
      paddingTop: '0px',
      paddingLeft: '0px',
      paddingRight: '11px',
      paddingBottom: '16px',
      position: 'absolute',
      width: '300px',
      textAlign: 'center',
    },
  },
  otpSubmit: {
    fontSize: '14px',
    background:
      'linear-gradient(180deg, rgba(0,102,204,1) 74%, rgba(123,174,225,1) 100%)',
    textTransform: 'capitalize',
    marginTop: '15%',
  },
  otpResend: {
    fontSize: '12px',
    textTransform: 'capitalize',
    marginTop: '7px',
    fontWeight: 'bold',
    [theme.breakpoints.up('lg')]: { marginLeft: '20px' },
  },
  OTPtxtField: {
    backgroundColor: 'white',
    width: '100%',
  },
  uploadbutton: {
    width: '90px',
    height: '30px',
    backgroundColor: '#0066cc',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'rgb(13,57,113)',
    },
    fontSize: '8px',
    float: 'right',
  },

  txtFldLblView: {
    fontSize: '8px',
    fontWeight: 'bold',
  },
  acknowledgementHeaders: {
    color: 'black',
    fontSize: '12px',
  },
  acknowledgementpaper: {
    position: 'relative',
    padding: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      marginTop: '3%',
      marginBottom: '3%',
      paddingLeft: '5%',
      paddingRight: '5%',
      paddingBottom: '3%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
  },
  acknowledgementButton: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      background:
        'linear-gradient(180deg, rgba(0,102,204,1) 74%, rgba(123,174,225,1) 100%)',
      textTransform: 'none',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      marginTop: '1rem'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '12px',
      background:
        'linear-gradient(180deg, rgba(0,102,204,1) 74%, rgba(123,174,225,1) 100%)',
      textTransform: 'capitalize',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      marginTop: '1rem'
    },
  },
  documentContent: {
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing('0%', 0, 0, '26%'),
    },
    [theme.breakpoints.only('sm')]: {
      padding: theme.spacing('0%', 0, 0, '33%'),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing('0%', 0, 0, '5%'),
    },
  },
  datepicker: {
    padding: '18.5px, 14px',
  },
  dateadorn: {
    color: '#0055A5',
    paddingRight: '0rem',
  },
  boxSize: {
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  accountServicesLink: {
    fontSize: '1.5em',
    textDecoration: 'none'
  },
  accountServicesLinkCenter: {
    textAlign: 'center'
  },
  inlineErrorMessage: {
    color: '#D32F2F'
  },
}));
export { useStyles };
